export const environment = {
  production: true,
  apiURLService: '${API_GATEWAY_URL}',
  cdccorpApiURLService: '${CDC_CORP_API_URL}',
  banqi: '${SHOW_BANQI}',
  apiKeyCB: '${API_KEY_CB}',
  apiKeyPF: '${API_KEY_PF}',
  bandeira: '${BANDEIRA}',
  apis: {
    'cdc-cobranca': {
      url: '${CDC_COBRANCA}',
    },
    'vv-cred-contratos': {
      url: '${VV_CRED_CONTRATOS}'
    },
    'cdc-cobranca-orquestrador-registro': {
      url: '${CDC_COBRANCA_ORQUESTRADOR_REGISTRO}',
    },
    'vv-cred-parcelas': {
      url: '${VV_CRED_PARCELAS}',
    },
    'cdc-cobranca-mensageria-portal': {
      url: '${CDC_COBRANCA_MENSAGERIA_PORTAL}',
    },
    'cdc-portal-negociacao-cartao-bradesco': {
      url: '${CDC_PORTAL_NEGOCIACAO_CARTAO_BRADESCO}',
    },
    'cdc-cobranca-renegociacao-service': {
      url: '${CDC_COBRANCA_RENEGOCIACAO_SERVICE}',
    },
    'vv-cred-geolocalizacao': {
      url: '${VV_CRED_GEOLOCALIZACAO}',
    }
  }
};
